import { getData, postData, putData } from "./AdminService"

export async function postStudentsData(data) {
  const url = "/studentsDetails/addStudentsDetails"
  return await postData(url, data)
}

export async function checkIfStudentsTermExists(data) {
  const url = "/studentsDetails/checkTermDetails"
  return await postData(url, data)
}

export async function fetchStudentsDetails(data) {
  const branch = data?.branch
  const academicYear = data?.academicYear
  const url = `/studentsDetails/getStudentsDetailsByBranch?branch=${branch}&academicYear=${academicYear}`
  return await getData(url) 
}

export async function fetchAcademicDetails() {
  const url = "/studentsDetails/getAcademicYears"
  return await getData(url)
}

export async function updateStudentData(data) {
  const url = "/studentsDetails/updateStudentDetails"
  return await putData(url, data)
}

export async function fetchStudentDetailsByAdmission(data) {
  const admission = data?.admission
  const academicYear = data?.academicYear
  const url = `/studentsDetails/getStudentDetailsByAdmission?admission=${admission}&academicYear=${academicYear}`
  return await getData(url)
}

export async function getStudent(data) {
  const url = "/studentsDetails/getStudentsDetails"
  return await postData(url, data)
}

export async function createOrderDetails(data) {
  const url = "/studentsDetails/create/order"
  return await postData(url, data);
}

export async function updateOrderDetails(data) {
  const url = `/studentsDetails/order/update`;
  return await putData(url, data);
}

export async function userLogin(data) {
  const url = `/studentsDetails/verifyLogin`;
  return await postData(url,data)
}

export async function sendDiscountApproval(data) {
  const url = "/studentsDetails/discountApproval";
  return await postData(url,data)
}

export async function getAdminNotifications(data) {
  const url = "/studentsDetails/getAdminNotifications";
  return await postData(url,data)
}

export async function approveDiscountAmount(data) {
  const url = "/studentsDetails/approveDiscount";
  return await putData(url,data)
}

export async function rejectDiscountAmount(data) {
  const url = "/studentsDetails/rejectDiscount";
  return await putData(url,data)
}

export async function sendNotification(data) {
  const url = "/studentsDetails/sendNotification";
  return await postData(url,data)
}

export async function clearOneNotification(data) {
  const url = "/studentsDetails/clearSingleNotification"
  return await putData(url,data)
}

export async function deleteAllNotifications(data) {
  const url = "/studentsDetails/clearAllNotifications"
  return await putData(url,data)
}

export async function downloadPdf(data) {
  const url = `/studentsDetails/getPdf`
  return await postData(url,data)
}

export async function saveTemplateDetails(data) {
  const url = `/studentsDetails/saveTemplateDetails`
  return await postData(url,data)
}

export async function getTemplateDetails(data) {
  const url = `/studentsDetails/getTemplateDetails?branch=${data?.branch}`
  return await getData(url)
}

export async function getRejectedTemplateDetails(data) {
  const url = `/studentsDetails/getRejectedTemplateDetails?branch=${data?.branch}`
  return await getData(url)
}

export async function deleteTemplateDetails(data) {
  const url = '/studentsDetails/deleteTemplateDetails'
  return await putData(url,data)
}

export async function editTemplateDetails(data) {
  const url = '/studentsDetails/editTemplateDetails'
  return await putData(url,data)
}

export async function saveTemplateApprovalDetails(data) {
  const url = '/studentsDetails/saveTemplateApproval'
  return await postData(url,data)
}

export async function editTemplateApprovalDetails(data) {
  const url = '/studentsDetails/editTemplateApproval'
  return await postData(url,data)
}

export async function approveTemplateDetails(data) {
  const url = '/studentsDetails/approveTemplate'
  return await postData(url,data)
}

export async function rejectTemplateDetails(data) {
  const url = '/studentsDetails/rejectTemplate'
  return await postData(url,data)
}

export async function saveMediaFiles(data) {
  const url = '/studentsDetails/saveMedia'
  return await postData(url,data)
}

export async function getMediaFiles(data) {
  const url = `/studentsDetails/getMedia?branch=${data?.branch}`
  return await getData(url)
}

export async function saveAuditLogs(data) {
  const url = `/studentsDetails/saveAuditLogs`
  return await postData(url,data)
}

export async function addPenality(data) {
  const url = `/studentsDetails/addPenality`
  return await postData(url,data)
}